import { useState } from 'react';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  // Mock data for markets
  const marketData = [
    { pair: 'BTC/USDT', price: '$65,432.10', change: '+2.35%', volume: '$1.2B' },
    { pair: 'ETH/USDT', price: '$3,456.78', change: '-1.23%', volume: '$980M' },
    { pair: 'BNB/USDT', price: '$543.21', change: '+0.87%', volume: '$650M' },
    { pair: 'XRP/USDT', price: '$0.8765', change: '+3.45%', volume: '$430M' },
    { pair: 'ADA/USDT', price: '$0.6543', change: '-2.10%', volume: '$320M' },
  ];
  
  // Mock data for news
  const newsData = [
    {
      title: 'Bitpin Announces New Fiat Deposit Methods',
      excerpt: 'We are excited to announce the addition of new fiat currency deposit options...',
      date: '2023-10-05'
    },
    {
      price: 'New Cryptocurrency Listings on Bitpin',
      excerpt: 'Bitpin will be listing three new cryptocurrencies this month...',
      date: '2023-10-04'
    },
    {
      title: 'Market Analysis: Bitcoin Surpasses $65K Milestone',
      excerpt: 'Bitcoin reaches new heights as institutional adoption accelerates...',
      date: '2023-10-03'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      {/* Header/Navbar */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <div className="flex-shrink-0">
              <a href="#" className="text-2xl font-bold text-blue-600">bitpin</a>
            </div>
            
            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              <a href="#" className="text-gray-700 hover:text-blue-600 transition-colors">صفحه اصلی</a>
              <a href="#" className="text-gray-700 hover:text-blue-600 transition-colors">بازارها</a>
              <a href="#" className="text-gray-700 hover:text-blue-600 transition-colors">معاملات</a>
              <a href="#" className="text-gray-700 hover:text-blue-600 transition-colors">حساب کاربری</a>
              <a href="#" className="text-gray-700 hover:text-blue-600 transition-colors">پشتیبانی</a>
            </nav>
            
            {/* Desktop Login / Register */}
            <div className="hidden md:flex items-center space-x-4 gap-x-4">
              <a href="#" className="text-gray-700 hover:text-blue-600 transition-colors">ورود</a>
              <a href="#" className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors">ثبت‌ نام</a>
            </div>
            
            {/* Mobile menu button */}
            <div className="md:hidden flex items-center">
              <button 
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 focus:outline-none"
              >
                {/* Hamburger Icon */}
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  {isMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>
        
        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <div className="container mx-auto px-4 py-3 space-y-3">
              <a href="#" className="block text-gray-700 hover:text-blue-600 transition-colors">صفحه اصلی</a>
              <a href="#" className="block text-gray-700 hover:text-blue-600 transition-colors">بازارها</a>
              <a href="#" className="block text-gray-700 hover:text-blue-600 transition-colors">معاملات</a>
              <a href="#" className="block text-gray-700 hover:text-blue-600 transition-colors">حساب کاربری</a>
              <a href="#" className="block text-gray-700 hover:text-blue-600 transition-colors">پشتیبانی</a>
              <div className="pt-2 space-y-2 border-t border-gray-100">
                <a href="#" className="block text-gray-700 hover:text-blue-600 transition-colors">ورود</a>
                <a href="#" className="block bg-blue-600 text-white text-center px-4 py-2 rounded-md hover:bg-blue-700 transition-colors">ثبت‌نام</a>
              </div>
            </div>
          </div>
        )}
      </header>

{/* Hero Section */}
<section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16 md:py-24">
  <div className="container mx-auto px-4 sm:px-6 lg:px-8">
    <div className="max-w-3xl">
      <h1 className="text-3xl md:text-5xl font-bold mb-6 leading-tight">
        آغاز معامله در بزرگترین صرافی ایران
      </h1>
      <p className="text-lg md:text-xl mb-8 opacity-90">
        با بیت‌پین سریع، امن و قابل اعتماد به خرید و فروش انواع ارزهای دیجیتال بپردازید.
      </p>
      <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 gap-x-4">
        <a href="#" className="bg-white text-blue-600 px-6 py-3 rounded-md font-medium text-center hover:bg-opacity-90 transition-colors">
          شروع کنید
        </a>
        <a href="#" className="bg-transparent border-2 border-white px-6 py-3 rounded-md font-medium text-center hover:bg-white hover:bg-opacity-20 transition-colors">
          نحوه کار
        </a>
      </div>
    </div>
  </div>
</section>

      {/* Market Data Section */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center mb-8">
            <h2 className="text-2xl font-bold text-gray-900">بازارهای رمزارز</h2>
            <a href="#" className="text-blue-600 hover:text-blue-800 text-sm font-medium">نمایش همه </a>
          </div>
          
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">جفت ارز</th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">قیمت</th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">تغییر</th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">حجم 24ساعته</th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {marketData.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.pair}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.price}</td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${parseFloat(item.change) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                      {item.change}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.volume}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm">
                      <a href="#" className="text-blue-600 hover:text-blue-800">مشاهده</a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900">ویژگی‌های بیت‌پین</h2>
            <p className="mt-4 max-w-2xl mx-auto text-gray-500">
              تجربه بهترین خدمات معاملاتی برای ارزهای دیجیتال در بیت‌پین
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">اقدامات امنیتی بالا</h3>
              <p className="text-gray-500">
                تمامی دارایی‌های کاربران تحت حفاظت سیستم‌های پیشرفته امنیتی ما قرار دارد.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">سرعت بالای معامله</h3>
              <p className="text-gray-500">
                موتور معامله‌گری هوشمند ما قادر به پردازش هزاران سفارش در ثانیه است.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">پشتیبانی 24/7</h3>
              <p className="text-gray-500">
                تیم پشتیبانی متخصص ما در تمام ساعات شبانه‌روز آماده کمک به شما است.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* News Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900">اخبار و رویدادها</h2>
            <a href="#" className="text-blue-600 hover:text-blue-800 text-sm font-medium hidden md:inline">نمایش همه </a>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {newsData.map((article, index) => (
              <div key={index} className="bg-gray-50 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
                <img src={`https://picsum.photos/seed/bitcoin ${index}/800/400`} alt="News" className="w-full h-48 object-cover" />
                <div className="p-6">
                  <span className="text-sm text-gray-500">{article.date}</span>
                  <h3 className="text-xl font-semibold mt-2 mb-3">{article.title}</h3>
                  <p className="text-gray-500 mb-4">{article.excerpt}</p>
                  <a href="#" className="text-blue-600 hover:text-blue-800 font-medium inline-flex items-center">
                    ادامه مطلب
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </a>
                </div>
              </div>
            ))}
          </div>
          
          {/* Mobile view show all button */}
          <div className="md:hidden mt-8 text-center">
            <a href="#" className="text-blue-600 hover:text-blue-800 text-sm font-medium">نمایش همه اخبار </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-700 text-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">آماده شروع کار با بیت‌پین هستید؟</h2>
          <p className="text-xl max-w-2xl mx-auto mb-8 opacity-90">
            ثبت نام کنید و اولین معامله خود را انجام دهید. فرآیند ساده و امن در انتظار شماست.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4 gap-x-4">
            <a href="#" className="bg-white text-blue-600 px-8 py-3 rounded-md font-medium hover:bg-opacity-90 transition-colors inline-block">
              ثبت‌ نام رایگان
            </a>
            <a href="#" className="bg-transparent border-2 border-white px-8 py-3 rounded-md font-medium hover:bg-white hover:bg-opacity-10 transition-colors inline-block">
              مشاهده آموزش
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-white text-lg font-semibold mb-4">در مورد بیت‌پین</h3>
              <ul className="space-y-2">
                <li><a href="#" className="hover:text-blue-400 transition-colors">درباره ما</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">همکاری با ما</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">تماس با ما</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">قوانین و مقررات</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">حریم خصوصی</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-white text-lg font-semibold mb-4">خدمات</h3>
              <ul className="space-y-2">
                <li><a href="#" className="hover:text-blue-400 transition-colors">خرید و فروش</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">کیف پول</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">استیکینگ</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">استخدام</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">API</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-white text-lg font-semibold mb-4">پشتیبانی</h3>
              <ul className="space-y-2">
                <li><a href="#" className="hover:text-blue-400 transition-colors">مرکز کمک</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">سوالات متداول</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">ارسال تیکت</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">راهنمای تصویری</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">راهنمای تلفنی</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-white text-lg font-semibold mb-4">شبکه‌های اجتماعی</h3>
              <div className="flex space-x-4 space-x-reverse">
                <a href="#" className="hover:text-blue-400 transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                  </svg>
                </a>
                <a href="#" className="hover:text-blue-400 transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"/>
                  </svg>
                </a>
                <a href="#" className="hover:text-blue-400 transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a href="#" className="hover:text-blue-400 transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 8v8c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-6 4H9c-.552 0-1 .448-1 1s.448 1 1 1h6c.552 0 1-.448 1-1s-.448-1-1-1zm4-6H5C3.9 6 3 6.9 3 8v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"/>
                  </svg>
                </a>
              </div>
              
              <div className="mt-8">
                <h4 className="text-white text-sm font-semibold mb-2">دانلود اپلیکیشن</h4>
                <div className="flex space-x-2 space-x-reverse">
                  <a href="#" className="hover:opacity-80 transition-opacity">
                    <img src="https://picsum.photos/seed/appstore/120/40 " alt="App Store" className="h-10" />
                  </a>
                  <a href="#" className="hover:opacity-80 transition-opacity">
                    <img src="https://picsum.photos/seed/googleplay/120/40 " alt="Google Play" className="h-10" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 py-4">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm">&copy; 2023 بیت‌پین - تمامی حقوق محفوظ است.</p>
            <div className="flex space-x-6 mt-4 md:mt-0 space-x-reverse">
              <a href="#" className="text-sm hover:text-blue-400 transition-colors">شرایط استفاده</a>
              <a href="#" className="text-sm hover:text-blue-400 transition-colors">حریم خصوصی</a>
              <a href="#" className="text-sm hover:text-blue-400 transition-colors">کاربرد ارزهای دیجیتال</a>
            </div>
          </div>
        </div>
        </footer>
    </div>
  );
}

export default App;